// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalLogoutAndDelete_modal__1aplM","title":"ModalLogoutAndDelete_title__1mFli","wrapper":"ModalLogoutAndDelete_wrapper__3001W"};